import React from 'react';
import {Header} from "../header";
import {withStyles} from "material-ui";

export class Base extends React.Component {

    render() {

        const {children, classes} = this.props;

        return (
            <div>
                <Header/>
                <main className={classes.container}>
                    {children}
                </main>
            </div>
        )
    }
}

const styles = theme => ({
    container: {
        height: 'calc(100vh - 64px)',
        background: '#fbfbfb',
    }
});

Base = withStyles(styles)(Base);


// WEBPACK FOOTER //
// ./src/components/base/index.js